//@flow
import type {DeliveryMethod} from '../../../../entities/logistic/delivery-method';

import type {
  AdvancedLocationAdmin1,
  AdvancedLocationAdmin2,
  AdvancedLocationAdmin3,
} from '../../../../entities/logistic/delivery-method/advanced';

function isLocationEnabled(
  location:
    | AdvancedLocationAdmin1
    | AdvancedLocationAdmin2
    | AdvancedLocationAdmin3,
  admin1?: string,
  admin2?: string,
  admin3?: string
): boolean {
  if (typeof location === 'boolean') {
    return location;
  }

  if (!admin1 || !location[admin1]) {
    return false;
  }

  const admin1Location = location[admin1];
  if (typeof admin1Location === 'boolean') {
    return admin1Location;
  }

  if (!admin2) {
    return true;
  }

  if (!admin1Location[admin2]) {
    return false;
  }

  const admin2Location = admin1Location[admin2];
  if (typeof admin2Location === 'boolean') {
    return admin2Location;
  }

  if (!admin3) {
    return true;
  }

  return admin2Location[admin3];
}

export function filterShippingMethods(
  methods: DeliveryMethod[],
  country: string,
  admin1?: string,
  admin2?: string,
  admin3?: string
): DeliveryMethod[] {
  const shouldFilter = methods.some(
    method => method.type === 'store-shipping-method-advanced-admin-group'
  );
  if (!shouldFilter) return methods;

  if (!admin1) {
    return methods;
  }
  const advancedMethods = methods;

  const filteredRates: DeliveryMethod[] = [];

  advancedMethods.forEach(method => {
    // $FlowFixMe
    const location = method.location[country];
    // $FlowFixMe
    if (location && isLocationEnabled(location, admin1, admin2, admin3)) {
      filteredRates.push(method);
    }
  });

  return filteredRates;
}
